// 利用規約チェック
import commonClass from "./commonClass";

export default class checkTermClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$prt = $('.js-checkterm');
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    // チェックON/OFFでテキストエリアのreadonly属性・リセットボタンの活性/非活性切り替え
    $(document).on('change', '.js-checkterm_editipt', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $txtarea = $prt.find('.js-checkterm_txtarea');
      var $reset = $prt.find('.js-checkterm_resetbtn');
      var $agreement = $prt.find('.js-checkterm_agrmbtn');
      var $membertype = $prt.find('.js-checkterm_mebtype');
      var $isinput = $prt.find('.js-checkterm_isinput');
      var $confirmbtn = $prt.find('.js-checkterm_confirm');
      var $extbtn = $prt.find('.js-checkterm_extbtn');
      var $prstsave = $prt.find('.js-checkterm_prstsave');
      var $isinput = $prt.find('.js-checkterm_isinput');
      var $resetbefore = $prt.find('.js-checkterm_resetbeforebtn');

      if ($(this).prop('checked')) {
        $txtarea.attr('readonly', false);
        $reset.removeClass('is-disable');
        $resetbefore.removeClass('is-disable');
        $agreement.removeClass('is-disable');
      } else {
        $txtarea.attr('readonly', true);
        $reset.addClass('is-disable');
        $resetbefore.addClass('is-disable');
        $agreement.addClass('is-disable');
      }

      if ($('input[name="membershipType"]:eq(0)').prop('checked')) {
        $membertype.prop('disabled', false);
      } else {
        $membertype.prop('disabled', true);
      }

      if ($('input[name="relateTargetChoice"]:eq(0)').prop('checked')) {
        if ($(this).val().length != 0) {
          $confirmbtn.removeClass('is-disable');
        } else {
          $confirmbtn.addClass('is-disable');
        }
      } else if ($('input[name="relateTargetChoice"]:eq(1)').prop('checked')) {
        if ($(this).val().length != 0) {
          $confirmbtn.removeClass('is-disable');
        } else {
          $confirmbtn.addClass('is-disable');
        }
      } else {
        $confirmbtn.addClass('is-disable');
      }

      if ($(this).val().length != 0) {
        $prstsave.prop('disabled', false);
        $extbtn.removeClass('is-disable');
      } else {
        $prstsave.prop('disabled', true);
        $extbtn.addClass('is-disable');
      }

      var $inputtext = $prt.find('input[type="text"]');
      // if ($inputtext.val().length == 0) {
      //   $isinput.addClass('is-disable');
      // } else {
      //   $isinput.removeClass('is-disable');
      // }
      if ($inputtext.length != 0) {
        if ($inputtext.val().length == 0) {
            $isinput.addClass('is-disable');
        } else {
            $isinput.removeClass('is-disable');
        }
      }

      return false;
    });

    $(document).on('click', '.js-checkterm_resetbtn', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $txtarea = $prt.find('.js-checkterm_txtarea');
      $txtarea.val('');
      return false;
    });

    $(document).on('change', '.js-checkterm_txtbox', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $tetsbmit = $prt.find('.js-checkterm_tetsbmit');
      if ($('.js-checkterm_txtbox').val().length != 0) {
        $tetsbmit.removeClass('is-disable');
      } else {
        $tetsbmit.addClass('is-disable');
      }
      return false;
    });

    var $filePath = $('.js-filePath');
    $filePath.css('display', 'none');
    $(document).on('change', '.js-checkterm_filebox', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $fileupldbtn = $prt.find('.js-checkterm_fileupldbtn');
      var $empirelistbtn = $prt.find('.js-empirelistbtn');
      var $filechk0 = $prt.find('.js-filechk0');
      var $filechk1 = $prt.find('.js-filechk1');
      var $filePath = $prt.find('.js-filePath');
      if ($filechk0.val().length != "") {
        $fileupldbtn.removeClass('is-disable');
        $empirelistbtn.addClass('is-disable');
        $filePath.css('display', 'none');
        $fileupldbtn.on('click', function () {
          $empirelistbtn.removeClass('is-disable');
          $fileupldbtn.removeClass('is-disable');
          $filePath.css('display', 'block');
        });
      } else {
        $fileupldbtn.addClass('is-disable');
        $empirelistbtn.addClass('is-disable');
        $filePath.css('display', 'none');
      }
      return false;
    });

    $(document).on('change', '.js-checkterm_lockchk', function () {
      var $btnlock = $(this).parents('td').prevAll('td').find('.js-checkterm_btnlock');
      var $slctlock = $(this).parents('td').prevAll('td').find('.js-checkterm_slctlock');
      if ($(this).prop('checked')) {
        $btnlock.addClass('is-disable');
        $slctlock.prop('disabled', true);
      } else {
        $btnlock.removeClass('is-disable');
        $slctlock.prop('disabled', false);
      }
      return false;
    });

    var btnlock_0 = $('.js-checkterm_btnlock:eq(0)');
    var btnlock_1 = $('.js-checkterm_btnlock:eq(1)');
    var btnlock_2 = $('.js-checkterm_btnlock:eq(2)');
    var btnlock_3 = $('.js-checkterm_btnlock:eq(3)');
    var btnlock_4 = $('.js-checkterm_btnlock:eq(4)');
    var btnlock_5 = $('.js-checkterm_btnlock:eq(5)');
    var btnlock_6 = $('.js-checkterm_btnlock:eq(6)');
    var btnlock_7 = $('.js-checkterm_btnlock:eq(7)');
    var btnlock_8 = $('.js-checkterm_btnlock:eq(8)');
    var btnlock_9 = $('.js-checkterm_btnlock:eq(9)');
    var slctlock_0 = $('.js-checkterm_slctlock:eq(0)');
    var slctlock_1 = $('.js-checkterm_slctlock:eq(1)');
    var slctlock_2 = $('.js-checkterm_slctlock:eq(2)');
    var slctlock_3 = $('.js-checkterm_slctlock:eq(3)');
    var slctlock_4 = $('.js-checkterm_slctlock:eq(4)');
    var slctlock_5 = $('.js-checkterm_slctlock:eq(5)');
    var slctlock_6 = $('.js-checkterm_slctlock:eq(6)');
    var slctlock_7 = $('.js-checkterm_slctlock:eq(7)');
    var slctlock_8 = $('.js-checkterm_slctlock:eq(8)');
    var slctlock_9 = $('.js-checkterm_slctlock:eq(9)');
    var slctVal_0 = $('[name=slct_controll]:eq(0)');
    var slctVal_1 = $('[name=slct_controll]:eq(1)');
    var slctVal_2 = $('[name=slct_controll]:eq(2)');
    var slctVal_3 = $('[name=slct_controll]:eq(3)');
    var slctVal_4 = $('[name=slct_controll]:eq(4)');
    var slctVal_5 = $('[name=slct_controll]:eq(5)');
    var slctVal_6 = $('[name=slct_controll]:eq(6)');
    var slctVal_7 = $('[name=slct_controll]:eq(7)');
    var slctVal_8 = $('[name=slct_controll]:eq(8)');
    var slctVal_9 = $('[name=slct_controll]:eq(9)');
    var lockchk_0 = $('.js-checkterm_lockchk:eq(0)');
    var lockchk_1 = $('.js-checkterm_lockchk:eq(1)');
    var lockchk_2 = $('.js-checkterm_lockchk:eq(2)');
    var lockchk_3 = $('.js-checkterm_lockchk:eq(3)');
    var lockchk_4 = $('.js-checkterm_lockchk:eq(4)');
    var lockchk_5 = $('.js-checkterm_lockchk:eq(5)');
    var lockchk_6 = $('.js-checkterm_lockchk:eq(6)');
    var lockchk_7 = $('.js-checkterm_lockchk:eq(7)');
    var lockchk_8 = $('.js-checkterm_lockchk:eq(8)');
    var lockchk_9 = $('.js-checkterm_lockchk:eq(9)');
    $(document).on('change', '.js-checkterm_lockchk', function () {
      for (var i = 0; i < 10; i++) {
        if (eval('lockchk_' + i).prop('checked')) {
          eval('btnlock_' + i).addClass('is-disable');
          eval('slctlock_' + i).prop('disabled', true);
        } else if (eval('slctVal_' + i).val().length == 0) {
          eval('btnlock_' + i).addClass('is-disable');
          eval('slctlock_' + i).prop('disabled', false);
        } else {
          eval('btnlock_' + i).removeClass('is-disable');
          eval('slctlock_' + i).prop('disabled', false);
        }
      }
      return false;
    });


    var slctVal_0 = $('[name=slct_controll]:eq(0)');
    var slctVal_1 = $('[name=slct_controll]:eq(1)');
    var slctVal_2 = $('[name=slct_controll]:eq(2)');
    var slctVal_3 = $('[name=slct_controll]:eq(3)');
    var slctVal_4 = $('[name=slct_controll]:eq(4)');
    var slctVal_5 = $('[name=slct_controll]:eq(5)');
    var slctVal_6 = $('[name=slct_controll]:eq(6)');
    var slctVal_7 = $('[name=slct_controll]:eq(7)');
    var slctVal_8 = $('[name=slct_controll]:eq(8)');
    var slctVal_9 = $('[name=slct_controll]:eq(9)');
    var ExecuteBtn_0 = $('.js-slct_controllnbtn:eq(0)');
    var ExecuteBtn_1 = $('.js-slct_controllnbtn:eq(1)');
    var ExecuteBtn_2 = $('.js-slct_controllnbtn:eq(2)');
    var ExecuteBtn_3 = $('.js-slct_controllnbtn:eq(3)');
    var ExecuteBtn_4 = $('.js-slct_controllnbtn:eq(4)');
    var ExecuteBtn_5 = $('.js-slct_controllnbtn:eq(5)');
    var ExecuteBtn_6 = $('.js-slct_controllnbtn:eq(6)');
    var ExecuteBtn_7 = $('.js-slct_controllnbtn:eq(7)');
    var ExecuteBtn_8 = $('.js-slct_controllnbtn:eq(8)');
    var ExecuteBtn_9 = $('.js-slct_controllnbtn:eq(9)');
    $(document).on('change', '.js-slct_controll', function () {
      for (var i = 0; i < 10; i++) {
        if (eval('slctVal_' + i).val().length == 0) {
          eval('ExecuteBtn_' + i).addClass('is-disable');
        } else {
          eval('ExecuteBtn_' + i).removeClass('is-disable');
        }
      }
      return false;
    });

    var $keyunlock = $('.js-checkterm_keyunlock');
    var $keylock = $('.js-checkterm_keylock');
    $keylock.css('display', 'none');
    $('button.key_unlock').click(function () {
      $keyunlock.css('display', 'none');
      $keylock.css('display', 'block');
    });
    $('button.key_lock').click(function () {
      $keyunlock.css('display', 'block');
      $keylock.css('display', 'none');
    });

    $(document).on('click', '.js-checkterm_resetbeforebtn', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $txtarea = $prt.find('.js-checkterm_txtarea');
      var $textcontent = $txtarea.text();
      $txtarea.val($textcontent);
      $txtarea.addClass('has-val');

      return false;
    });

    /* ログイン画面での入力処理 */
    $(document).on('change', '.js-checkterm_login', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $loginbtn = $prt.find('.js-checkterm_loginbtn');
      var $mail = $prt.find('.mail-input');
      var $password = $prt.find('.password-input');

      if ($mail.val().length == 0 || $password.val().length == 0) {
        $loginbtn.addClass('is-disable');
      } else {
        $loginbtn.removeClass('is-disable');
      }
      return false;
    });

    /* 利用規約同意画面での処理 */
    $(document).on('change', '.js-checkterm_agreement', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $agreementbtn = $prt.find('.js-checkterm_agreementbtn');
      var $ldc_agreement = $prt.find('.ldcAgreement');
      var $dl_agreement = $prt.find('.dlAgreement');

      if ($ldc_agreement.prop('checked') && $dl_agreement.prop('checked')) {
        $agreementbtn.removeClass('is-disable');
      } else {
        $agreementbtn.addClass('is-disable');
      }
      return false;
    });

    /* ワンタイムパスワード設定での処理 */
    var otpapp_cls = $('.otpapp');
    var otpsms_cls = $('.otpsms');
    var otpradio_0 = $('input[name="otptype"]:eq(0)');
    var otpradio_1 = $('input[name="otptype"]:eq(1)');

    otpsms_cls.css('display', 'none');
    $(document).on('click', '.js-checkterm_otptype', function () {
      if (otpradio_0.prop('checked')) {
        otpapp_cls.css('display', 'flex');
        otpsms_cls.css('display', 'none');
      } else {
        otpapp_cls.css('display', 'none');
        otpsms_cls.css('display', 'flex');
      }
    });

    /*会員タイプパーツ出し分け*/
    var select_0 = $('#select0');
    var select_1 = $('#select1');
    var select_2 = $('#select2');
    var select_3 = $('#select3');
    var select_4 = $('#select4');
    var inputselect_0 = $('input[name="membertype"]:eq(0)');
    var inputselect_1 = $('input[name="membertype"]:eq(1)');
    var inputselect_2 = $('input[name="membertype"]:eq(2)');
    var inputselect_3 = $('input[name="membertype"]:eq(3)');
    var inputselect_4 = $('input[name="membertype"]:eq(4)');

    for (var i = 1; i < 5; i++) {
      eval('select_' + i).css('display', 'none');
    }
    $(document).on('click', '.js-checkterm_selectmebtype', function () {
      for (var i = 0; i < 5; i++) {
        if (eval('inputselect_' + i).prop('checked')) {
          eval('select_' + i).css('display', 'flex');
        } else {
          eval('select_' + i).css('display', 'none');
        }
      }
    });

    /*関連対象選択出し分けパーツ*/
    var relation_id = $('#relation_id');
    var relateTarget_0 = $('input[name="relateTargetChoice"]:eq(0)');
    var relateTarget_1 = $('input[name="relateTargetChoice"]:eq(1)');
    var relateTarget_2 = $('input[name="relateTargetChoice"]:eq(2)');
    var $InputID = $('.js-InputID');

    $(document).on('click', '.js-checkterm_relationtarget', function () {
      for (var i = 1; i < 3; i++) {
        if (eval('relateTarget_2').prop('checked')) {
          relation_id.find('button').addClass('is-disable');
        } else if (eval('relateTarget_0').prop('checked') != 0 && $InputID.val().length != 0) {
          relation_id.find('button').removeClass('is-disable');
        } else if (eval('relateTarget_1').prop('checked') != 0 && $InputID.val().length != 0) {
          relation_id.find('button').removeClass('is-disable');
        } else {
          relation_id.find('button').addClass('is-disable');
        }
      }
    });

    $(document).on('change', '.js-checkterm_txtbox', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $upldbtn = $prt.find('.js-checkterm_upldbtn');
      if (($('.js-checkterm_txtbox:eq(0)').val().length != 0) &&
        ($('.js-checkterm_txtbox:eq(1)').val().length != 0)) {
        $upldbtn.removeClass('is-disable');
      } else {
        $upldbtn.addClass('is-disable');
      }
    });

    /*全てのテキストボックスに入力した場合ボタンを活性化*/
    $(document).on('change', '.js-checkterm_txtbox', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $sbmitbtn = $prt.find('.js-checkterm_sbmit');
      if (($('.js-checkterm_txtbox:eq(0)').val().length != 0) &&
        ($('.js-checkterm_txtbox:eq(1)').val().length != 0) &&
        ($('.js-checkterm_txtbox:eq(2)').val().length != 0)) {
        $sbmitbtn.removeClass('is-disable');
      } else {
        $sbmitbtn.addClass('is-disable');
      }
    });

    /*全て入力されたらボタン押下可になる処理*/
    $(document).on('change', '.js-checkterm_componentTxtchk', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $componentUpldBtn = $prt.find('.js-checkterm_componentUpldBtn');
      var $txtlist = $prt.find('.js-checkterm_txtlist');
      var $txtid = $prt.find('.js-checkterm_txtid');
      var $filechk = $prt.find('.js-checkterm_fileChk');
      if ($txtlist.val().length != "" && $txtid.val().length != "" && $filechk.val().length != "") {
        $componentUpldBtn.removeClass('is-disable');
      } else {
        $componentUpldBtn.addClass('is-disable');
      }
    });

    /*申込日が入力されたらボタン押下可になる処理*/
    $(document).on('change', '.js-AppDate-chk', function () {
      var $prt = $(this).closest('.js-checkterm');
      var $AppDatechkbtn = $prt.find('.js-AppDate-chkbtn');
      var $slctHour1 = $('[name=slct-hour-chk1]').val();
      var $slctHour2 = $('[name=slct-hour-chk2]').val();
      if ($('#js-date-chk1').find('.has-val').length && $slctHour1 != "" && $('#js-date-chk2').find('.has-val').length && $slctHour2 != "") {
        $AppDatechkbtn.removeClass('is-disable');
      } else {
        $AppDatechkbtn.addClass('is-disable');
      }
    });

    var semonly_id = $('#semonly');
    var semonly_cls = $('.semonly');
    var caseonly = $('#caseonly');
    // var inputradio_1 = $('input[name="exclusion"]:eq(1)');
    var inputradio_1 = $('input[name="Cond.ExcludeContentsType"]:eq(1)');
    var attr_semonly_id = $('#attr-semonly');
    var attr_caseonly_id = $('#attr-caseonly');
    // var inputradio_2 = $('input[name="attribute"]:eq(1)');
    var inputradio_2 = $('input[name="Cond.AccessLogContentsType"]:eq(1)');

    semonly_id.css('display', 'none');
    semonly_cls.css('display', 'none');
    $(document).on('click', '.js-checkterm_exclusion', function () {
      if (inputradio_1.prop('checked')) {
        semonly_id.css('display', 'block');
        semonly_cls.css('display', 'flex');
        caseonly.css('display', 'none');
      } else {
        semonly_id.css('display', 'none');
        semonly_cls.css('display', 'none');
        caseonly.css('display', 'flex');
      }
    });

    attr_semonly_id.css('display', 'none');
    $(document).on('click', '.js-checkterm_attribute', function () {
      if (inputradio_2.prop('checked')) {
        attr_semonly_id.css('display', 'flex');
        attr_caseonly_id.css('display', 'none');
      } else {
        attr_semonly_id.css('display', 'none');
        attr_caseonly_id.css('display', 'flex');
      }
    });

    var configlst = $('.js-configlst');
    configlst.css('display', 'none');
    $(document).on('click', '.js-configshow', function () {
      configlst.css('display', 'block');
    });
    $(document).on('click', '.js-del', function () {
      configlst.css('display', 'none');
    });

  }
}
